import { useEffect, useState, createContext, useContext, useCallback } from "react";
import { api } from "./api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [s, setS] = useState({
    clinic_name: "Dr. Dimy Laguerre",
    whatsapp_number: "",
    wise_pay_link: "",
    consultation_price_eur: 20,
    default_slot_minutes: 15,
  });
  const refresh = useCallback(() => {
    api.get("/settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <SettingsContext.Provider value={{ ...s, refresh }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext) || {};

export function buildWhatsAppLink(number, text) {
  const clean = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(text)}`;
}
